<template>
  <div>
    <div class="topbar">
      <van-row>
        <van-col span="3"> <i class="iconfont iconback" @click="onBack" /> </van-col>
        <van-col span="18" class="topTitle">{{ pagetitle }}</van-col>
        <van-col span="3"><i v-if="right" :class="'iconfont '+ right+(isRightSelect?' mainColor':'')" @click="onRight" /> </van-col>
      </van-row>
    </div>
    <div class="emptyRect" />
  </div>
</template>
<script>

export default {
  components: {
  },
  props: {
    // eslint-disable-next-line
    pagetitle: {
      default: 'SSI'
    },
    // eslint-disable-next-line
    backUrl: {
      default: '/home/index'
    },
    // eslint-disable-next-line
    right: {
      default: undefined
    },
    // eslint-disable-next-line
    isRightSelect: {
      default: false
    }
  },
  data() {
    return {

    }
  },
  created() {
    console.log('right', this.right)
  },
  methods: {
    onBack() {
      this.$emit('leftClick')
      this.$router.replace(this.backUrl)
    },
    onRight() {
      this.$emit('rightClick')
    }
  }
}
</script>
<style scoped>
.topbar{
    height: 3em;
    line-height: 3em;
    color: #fff;
    background-color: #000;
    position:fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    z-index: 101;
}
.topTitle{
      text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.topbar .van-col{
    text-align: center;
}
.emptyRect{
  height: 3em;
}
</style>
